import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * A custom element that manages a cart drawer.
 *
 * @extends {DialogComponent}
 */
class CartDrawerComponent extends DialogComponent {
  #autoOpenTimer;

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
    window.clearTimeout(this.#autoOpenTimer);
  }

  #handleCartAdd = () => {
    if (!this.hasAttribute('auto-open')) return;

    if (window.matchMedia('(max-width: 749px)').matches) {
      window.clearTimeout(this.#autoOpenTimer);
      this.#autoOpenTimer = window.setTimeout(() => {
        const crossSellDialog = document.querySelector('#cross-sell-popup dialog[open]');
        if (!crossSellDialog) this.showDialog();
      }, 150);
      return;
    }

    this.showDialog();
  };

  open() {
    this.showDialog();

    /**
     * Close cart drawer when installments CTA is clicked to avoid overlapping dialogs
     */
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document.querySelector('shopify-payment-terms')?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}
